import React from "react";
import SupportForm from "../../forms/support/CreateSupportForm";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CreateSupportContainer from "../../containers/support/CreateSupportContainer";

const CreateSupport = ({ handleClose, open }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("create_support.title")}
    >
      <CreateSupportContainer handleClose={handleClose}>
        {({ onSubmit, initialValues }) => (
          <SupportForm onSubmit={onSubmit} initialValues={initialValues} />
        )}
      </CreateSupportContainer>
    </Modal>
  );
};

export default CreateSupport;
